import { render, staticRenderFns } from "./QrForChildrenModal.vue?vue&type=template&id=bd966696&scoped=true&"
import script from "./QrForChildrenModal.vue?vue&type=script&lang=js&"
export * from "./QrForChildrenModal.vue?vue&type=script&lang=js&"
import style0 from "./QrForChildrenModal.vue?vue&type=style&index=0&id=bd966696&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd966696",
  null
  
)

export default component.exports